import { peso } from './format';

export const copy = {
  navLabel: 'Payments',
  title: 'Payments',
  loading: 'Loading…',
  add: 'Add',
  dueTitle: 'Payments due · next 30 days',
  nothingDue: 'Nothing due in the next 30 days.',
  emptyTitle: 'Everything you have to pay, in one list.',
  emptyBody: 'Add a bill, a utility, a credit card or a loan. Each one schedules its dues.',
  billsTitle: 'Bills and utilities',
  cardsTitle: 'Cards',
  loansTitle: 'Loans',
  addKinds: {
    bill: 'Add bill',
    utility: 'Add utility',
    card: 'Add card',
    loan: 'Add loan',
  },
  estimated: 'estimated',
  pay: 'Pay',
  payFull: (minor: number) => `Pay ${peso(minor)}`,
  payMinimum: (minor: number) => `Pay minimum ${peso(minor)}`,
  payOther: 'Other amount',
  payShare: (to: string) => `Pay your share to ${to}`,
  paidToast: (minor: number) => `Paid ${peso(minor)}`,
  partialToast: (left: number) => `Paid. ${peso(left)} still due`,
  undo: 'Undo',
  // Settings (v0.7.4)
  settings: 'Settings',
  more: 'More',
  whatsLeftPerCutoff: "What's left per cutoff",
  settingsTitle: 'Payments settings',
  payFromDefault: 'Pay from by default',
  payFromDefaultHelp:
    "Payments come out of this account when a bill, card or loan doesn't have its own.",
  sameAsBudget: 'Same as Budget',
  sameAsBudgetNamed: (name: string) => `Same as Budget (${name})`,
  addAccountsFirst: 'Add your accounts in Budget first.',
  addAccount: 'Add an account',
  remindTitle: 'Remind me … days before',
  remindHelp:
    'New bills, cards and loans start with this. A due shows as due soon this many days before.',
  daysN: (n: number) => (n === 1 ? '1 day' : `${n} days`),
  settingsError: "That didn't save. Try again.",
  skip: 'Skip this one',
  skippedToast: 'Skipped',
  closeRest: "Close, rest won't be paid",
  closedToast: 'Closed',
  reopen: 'Open it again',
  enterAmount: "Enter this month's amount",
  realStatement: 'Type the real statement amount',
  realMinimum: 'Type the real minimum',
  amount: 'Amount',
  paidOn: 'Paid on',
  save: 'Save',
  cancel: 'Cancel',
  thatsTheWholeBill: 'This was the whole amount this time',
  autoPayAsk: (name: string, minor: number) => `Did ${name} auto-pay ${peso(minor)}?`,
  confirm: 'Confirm',
  differentAmount: 'Different amount',
  transferNote:
    "Paying a card is a transfer: the purchases already counted when you made them, so it isn't spending again.",
  noSpending: 'Spending is off, so this payment is recorded here only.',
  payments: 'Payments',
  history: 'History',
  noHistory: 'Nothing paid yet.',
  edit: 'Edit',
  delete: 'Delete',
  deletedToast: (name: string) => `${name} deleted`,
  notFound: "This payment isn't here anymore.",
  // Cards
  balance: 'Balance',
  available: 'Available credit',
  nextStatement: 'Next statement',
  statements: 'Statements',
  installments: 'Installments',
  addInstallment: 'Add installment',
  noInstallments: 'No installments on this card.',
  monthsOf: (paid: number, months: number) => `${paid} of ${months} months`,
  monthlyFor: (monthly: number, months: number) => `${peso(monthly)} × ${months}`,
  leftOn: (minor: number) => `${peso(minor)} left`,
  installmentSaved: 'Installment saved',
  installmentDeleted: 'Installment deleted',
  statementParts: 'Purchases, installments and carried balance',
  carried: 'Carried from last statement',
  opening: 'Balance when added',
  purchases: 'Purchases',
  rolled: 'Carried over',
  supplementary: (holder: string) => `Supplementary card · main cardholder ${holder}`,
  // Loans
  loanLeft: 'Left to pay',
  paidSoFar: 'Paid so far',
  projected: 'Projected',
  paymentsLeft: (n: number) => `${n} ${n === 1 ? 'payment' : 'payments'} left`,
  payoff: 'Paid off',
  payoffNever: "At this rate the balance doesn't go down. Pay more than the interest.",
  interestSoFar: (minor: number) => `Interest so far ${peso(minor)} (estimated)`,
  payAnyAmount: 'Pay any amount',
  // Tiles
  nextPayment: 'Next payment',
  dueThisWeek: 'Due this week',
  cardBalances: 'Card balances',
  lateCount: (n: number) => `${n} late`,
  allClear: 'Nothing due soon.',
  noCards: 'No cards yet.',
};

const ERRORS: Record<string, string> = {
  name_required: 'Give it a name.',
  name_too_long: 'Keep the name under 40 characters.',
  amount_required: 'Enter the amount.',
  bad_amount: 'Enter an amount above zero.',
  bad_day: 'Pick a day of the month.',
  bad_date: 'Pick a real date.',
  bad_every: 'Repeat every 1 to 24.',
  end_before_start: 'The end date is before the start.',
  bad_count: 'Number of payments: 1 to 600.',
  statement_day_required: 'Enter the statement day.',
  bad_days_after: 'Days after the statement: 1 to 60.',
  lender_required: 'Who is the loan from?',
  count_or_end_required: 'Enter how many payments, or the last date.',
  principal_required: 'Enter the balance you owe.',
  bad_rate: 'Interest: 0 to 100% a month.',
  bad_last4: 'Last 4 digits: four numbers.',
  note_too_long: 'Keep the note under 200 characters.',
  item_required: 'What did you buy?',
  bad_months: 'Months: 1 to 120.',
  bad_month: 'Pick the first month.',
  not_open: 'This one is already settled.',
  not_found: "This payment isn't here anymore.",
};

export function errorText(code: string): string {
  return ERRORS[code] ?? 'Something went wrong. Try again.';
}
